// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_Buttons-styles-module--buttons--2bbUh"};